/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './theme/theme.sass';
import { ThemeProvider } from '@mui/material';
import { ToastProvider } from 'react-toast-notifications';
import { theme } from './theme/theme';
import './i18n';
import Store, { persistor } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import DealsListing from './components/deals/views/listing';
import DealDetails from './components/deals/views/forms/DealsCreate';
import BlastListing from './components/blast/views/listing';
import OrdersListing from './components/orders/views/listing';
import UsersListing from './components/users/views/listing';
import ReferrersListing from './components/referrers/views/listing';
import CustomersListing from './components/customers/views/listing';
import GroupsListing from './components/groups/views/listing';
import CommissionsListing from './components/commissions/views/listing';
import PayoutsListing from './components/payouts/views/listing';
import PromotionsListing from './components/promotions/views/listing';
import ProductsListing from './components/products/views/listing';
import RecomendationsListing from './components/recomendations/views/listing';
import MainSidebar from './core/MainSidebar';
import Pagination from './core/Pagination';
import GoogleAutocompleteService from './core/GoogleMaps/GoogleAutocompleteService';
import OrderIdContextProvider from './components/orders/context/orderIdContext';
import TrendingListing from './components/trending/views/listing';

export { MainSidebar };
export { Pagination };
export { GoogleAutocompleteService };


const ContainerMainSidebar = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <MainSidebar {...props} />
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerMainSidebar };

const ContainerDealDetails = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <DealDetails {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
</ThemeProvider>
);

export { ContainerDealDetails };

const ContainerDealsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <DealsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerDealsListing };


const ContainerBlastListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <BlastListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerBlastListing };


const ContainerOrdersListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <OrderIdContextProvider>
        <PersistGate loading={null} persistor={persistor}>
          <ToastProvider placement="bottom-right">
            <OrdersListing {...props} />
          </ToastProvider>
        </PersistGate>
      </OrderIdContextProvider>
    </Provider>
  </ThemeProvider>
);

export { ContainerOrdersListing };
  
const ContainerUsersListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <UsersListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerUsersListing };


const ContainerReferrersListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <ReferrersListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerReferrersListing };


const ContainerCustomersListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <CustomersListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerCustomersListing };


const ContainerGroupsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <GroupsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerGroupsListing };

const ContainerCommisionsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <CommissionsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerCommisionsListing };

const ContainerPayoutsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <PayoutsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerPayoutsListing };

const ContainerPromotionsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <PromotionsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerPromotionsListing };

const ContainerProductsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <ProductsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerProductsListing };

const ContainerTrendingListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <TrendingListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerTrendingListing };

const ContainerRecomendationsListing = (props) => (
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider placement="bottom-right">
          <RecomendationsListing {...props} />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export { ContainerRecomendationsListing };